import { render, staticRenderFns } from "./MaxRewardPerStore.vue?vue&type=template&id=bb630df0&scoped=true&"
import script from "./MaxRewardPerStore.vue?vue&type=script&lang=js&"
export * from "./MaxRewardPerStore.vue?vue&type=script&lang=js&"
import style0 from "./MaxRewardPerStore.vue?vue&type=style&index=0&id=bb630df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb630df0",
  null
  
)

export default component.exports